import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export interface LinkInternoVoltarData {
  title: string;
  page: string;
}

@Component({
  selector: 'fcp-link-interno-voltar',
  templateUrl: './link-interno-voltar.component.html',
  styleUrls: ['./link-interno-voltar.component.scss']
})
export class LinkInternoVoltarComponent implements OnInit {

  @Input() public linkInternoVoltar: LinkInternoVoltarData;
  @Output() public wasClickedPage: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  public emitClick(): void {
    this.wasClickedPage.emit(this.linkInternoVoltar.page);
  }

}
